import React from 'react';
import styled from '@benzinga/themetron';
import { formatPrice } from '@benzinga/utils';
import { QuoteChangePercent } from '@benzinga/quotes-ui';
import { Future } from '@benzinga/commodities-manager';

interface FuturesTableProps {
  futures?: Future[];
}

export const FuturesTableCompact: React.FC<FuturesTableProps> = ({ futures }) => {
  return (
    <FuturesTableWrapper>
      <table>
        <thead>
          <tr>
            <th>Futures</th>
            <th></th>
            <th>Change %</th>
            <th>Close Price</th>
          </tr>
        </thead>
        <tbody>
          {futures?.map(future => {
            const change = future.close - future.open;
            const percentageChange = (change / future.close) * 100;
            return (
              <tr key={future.symbol}>
                <td className="symbol">
                  <a href={`/futures/${future.symbol}`}>{future.symbol}</a>
                </td>
                <td className="name">
                  <a href={`/futures/${future.symbol}`}>{future.name}</a>
                </td>
                <td className="change-percent">
                  <QuoteChangePercent percentageChange={percentageChange} />
                </td>
                <td className="close">${formatPrice(future.close)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="note">Note: This futures data is based on end of day data.</div>
    </FuturesTableWrapper>
  );
};

const FuturesTableWrapper = styled.div`
  width: 100%;
  text-align: left;
  .note {
    font-size: 0.8rem;
    font-style: italic;
    margin-top: 0.2rem;
  }
  thead {
    tr {
      border-bottom: solid 1px #ccc;
    }
    th {
      font-size: 0.7rem;
    }
  }
  td,
  th {
    padding: 0.25rem 0;
  }
  tr {
    border-bottom: solid 1px #ddd;
  }
  td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    &.symbol {
      width: 40px;
      max-width: 40px;
    }
    &.name {
      width: 120px;
      max-width: 120px;
    }
    &.close {
      font-weight: bold;
    }
    &.close,
    &.date,
    &.change-percent,
    &.change {
      width: 100px;
      max-width: 100px;
    }
  }
`;
